import React from 'react';
import { Link } from 'react-router-dom';
import LogoTray from './components/LogoTray';
import PageHeading from './components/PageHeading';
import policy from './privacyPolicy.json';
import './Search.css';
import './About.css';

export default function Privacy() {
  return <div className="about-container">
    <LogoTray />
    <main className="about-content">
      <PageHeading eyebrow="JaoSVE! · SkaljaDev" title="Politika privatnosti">Verzija {policy.date}. Kontakt: <a href="mailto:info@jaosve.com">info@jaosve.com</a></PageHeading>
      {policy.sections.map(section => <section id={section.id} className="about-section" key={section.title}>
        <h2>{section.title}</h2>
        {section.paragraphs.map(text => <p key={text}>{text}</p>)}
      </section>)}
      <p><Link to="/delete-account">Brisanje računa</Link> · <a href="mailto:info@jaosve.com">Kontakt za privatnost</a></p>
    </main>
  </div>;
}
